<template>
    <Modal small v-on="$listeners">
        <SectionTitle :title="config.PROFILE_DELETE_TITLE"/>
        <SectionPicture>
            <ArtWarning :color="config.COLOR_WARNING"/>
        </SectionPicture>
        <SectionText :text="config.PROFILE_DELETE_DESCRIPTION"/>
        <SectionActions>
            <Button :color="config.COLOR_WARNING" :disabled="loading" outline @click="onCancel">
                {{ config.PROFILE_DELETE_CANCEL }}
            </Button>
            <Button :color="config.COLOR_WARNING" :disabled="loading" @click="onConfirm">
                {{ config.PROFILE_DELETE_CONFIRM }}
            </Button>
        </SectionActions>
    </Modal>
</template>
<script>
import { SolutionConsumer, UserConsumer } from '../../mixins';
import {
    SectionPicture, SectionTitle, SectionText, SectionActions,
} from '../../components/shared';

export default {
    name: 'ModalProfileDelete',
    components: {
        SectionPicture, SectionTitle, SectionText, SectionActions,
    },
    mixins: [SolutionConsumer, UserConsumer],
    data () {
        return {
            loading: false,
        };
    },
    methods: {
        onCancel () {
            this.$emit('close');
        },
        async onConfirm () {
            try {
                this.loading = true;
                await this.deleteUser();
                await this.logout();
                this.$emit('done');
            } catch (err) {
                console.log(err);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
